import React, { PropTypes } from 'react';
import { TimelineLite } from 'gsap';
import Display from '../parts/display';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as siteActions from '../../actions/siteActions';
import ReactCSSTransitionReplace from 'react-css-transition-replace';
import { ScrollToPlugin } from 'gsap';
import _find from 'lodash/find';
import _filter from 'lodash/filter';
import { browserHistory, Link } from 'react-router';
import ClientsBlock from '../clientsBlock';
import BlogBlock from '../blogBlock';

class BlogPostPage extends React.Component {
	constructor() {
		super();
		this.state = {
			animated: false,
			selected: '',
			pageSlug: false
		};
		this.tl = new TimelineLite();
		this.formatDate = this.formatDate.bind(this);
	}
	componentWillMount() {
		window.scrollTo(0, 0);
	}
	componentDidMount() {

		this.props.actions.showNavBar(true);
		this.props.actions.showMenu(true);
		if ((this.props.location.pathname.match(/\//g) || []).length == 2) {
			let name = this.props.location.pathname.substring(6, this.props.location.pathname.length);
			this.props.actions.loadService(_find(this.props.site.services, { slug: name }));
			this.setState({
				pageSlug: name
			});

			for (var i = 0; i < this.props.site.posts.length; i++) {
				//console.log(this.props.site.posts[i].slug);
				if (this.props.site.posts[i].slug === name) {
					this.props.actions.loadBlogPost(this.props.site.posts[i].id);
				}
			}

		}


		if (this.props.site.posts.length < 4) {
			this.props.actions.loadBlogPosts(3, 1);
		}
	}
	componentWillReceiveProps(next) {
		if (this.props.site.pageChange !== next.site.pageChange) {
			let name = next.site.pageChange.next.substring(6, next.site.pageChange.next.length);
			this.props.actions.loadBlogPost(name);
			this.tl.to(window, .6, { scrollTo: 0 });
		}
	}
	portfolioSelected(name) {
		this.setState({
			selected: name
		});
	}
	updateItems(slug) {
		if (slug === 'any') {
			this.props.actions.loadService(_find(this.props.site.services, { slug: slug }));
			this.props.actions.clearSelectedService();
		} else {
			this.props.actions.loadService(_find(this.props.site.services, { slug: slug }));
		}
	}
	listServices(service, index) {
		return <li key={index}>
			<Link to={{
				pathname: '/blog',
				query: {
					slug: service.slug,
					taxonomy: service.taxonomy
				}
			}}>
				<span dangerouslySetInnerHTML={{ __html: service.name }} ></span>
			</Link>
		</li>
	}
	getServiceType(type) {
		return _filter(this.props.site.services, { type: type });
	}
	componentWillUnmount() {
		this.props.actions.clearState();
	}
	formatDate(dateString) {
		var monthNames = [
			"January", "February", "March",
			"April", "May", "June", "July",
			"August", "September", "October",
			"November", "December"
		];

		var date = new Date(dateString);
		var day = date.getDate();
		var monthIndex = date.getMonth();
		var year = date.getFullYear();

		return day + ' ' + monthNames[monthIndex] + ' ' + year;
	}
	loadMorePosts() {
		this.props.actions.loadBlogPosts(6, this.props.site.postsPage + 1);
	}
	render() {

		return (
			<div className="services-page animated fadeIn portfolio-page blog-post-page">
				<div className="portfolio-top">
					<div className="container">
						<div className="row">
							<ReactCSSTransitionReplace transitionName="cross-fade" transitionEnterTimeout={300} transitionLeaveTimeout={300}>
								<div key={this.props.site.selectedPost.id}>
									<Display if={!this.props.site.loadingPost}><h1 dangerouslySetInnerHTML={{ __html: '<span>/</span>' + (this.props.site.selectedPost.title ? this.props.site.selectedPost.title.rendered : '') }}></h1></Display>
									<Display if={this.props.site.loadingPost}><div className="title-loading"><div></div><div></div></div></Display>
								</div>
							</ReactCSSTransitionReplace>
							<div className="dash-separator"></div>
							<ReactCSSTransitionReplace transitionName="cross-fade" transitionEnterTimeout={300} transitionLeaveTimeout={300}>
								<div key={this.props.site.selectedPost.id}>
									<Display if={!this.props.site.loadingPost}><p className="posted-by">Posted by Indigo {this.props.site.selectedPost._embedded ? this.props.site.selectedPost._embedded.author[0].name : ''},&nbsp;
										{/*{this.props.site.selectedPost._embedded? this.props.site.selectedPost._embedded['wp:term'][0][0].name: ''},&nbsp;*/}
										{this.formatDate(this.props.site.selectedPost.date)}</p></Display>
									<Display if={this.props.site.loadingPost}><div className="author-loading"><div></div><div></div></div></Display>
								</div>
							</ReactCSSTransitionReplace>
						</div>
					</div>
				</div>
				<div className="post-content">
					<div className="container">
						<div className="row">
							<div className="col-md-9 text-block">
								<ReactCSSTransitionReplace transitionName="cross-fade" transitionEnterTimeout={300} transitionLeaveTimeout={300}>
									<div key={this.props.site.selectedPost.id}>
										<Display if={!this.props.site.loadingPost}>
											<Display if={this.props.site.selectedPost.featured_media}>
												<img className="article-img" src={this.props.site.selectedPost.better_featured_image ? this.props.site.selectedPost.better_featured_image.media_details.sizes.medium_large ? this.props.site.selectedPost.better_featured_image.media_details.sizes.medium_large.source_url : this.props.site.selectedPost.better_featured_image.media_details.sizes.medium.source_url : ''} />
											</Display>
										</Display>
										<Display if={this.props.site.loadingPost}><div className="image-loading"></div></Display>
										<Display if={!this.props.site.loadingPost}>
											<div className="article-text" dangerouslySetInnerHTML={{ __html: this.props.site.selectedPost.content ? this.props.site.selectedPost.content.rendered : '' }}></div>
										</Display>
										<Display if={this.props.site.loadingPost}><div className="text-loading">
											<div></div><div></div>
											<div></div><div></div>
											<div></div><div></div>
											<div></div><div></div>
											<div></div><div></div>
											<div></div><div></div>
											<div></div><div></div>
											<div></div><div></div>
										</div>
										</Display>
									</div>
								</ReactCSSTransitionReplace>
							</div>
							<div className="col-md-3 categories-block">
								<h3>Categories</h3>
								<ul className="categories-list">
									{this.props.site.services.map(this.listServices)}
								</ul>
							</div>
						</div>

					</div>
				</div>
				<BlogBlock posts={this.props.site.posts} related={true} maxPosts={3} currentId={this.props.site.selectedPost.id} loading={this.props.site.loadingPosts} />
				<ClientsBlock clients={this.props.site.selectedClients} />
			</div>
		);
	}
}

function mapStateToProps(state, ownProps) {
	return {
		site: state.site
	};
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(siteActions, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(BlogPostPage);



/** WEBPACK FOOTER **
 ** ./src/js/components/blog/blogPostPage.js
 **/